import type { Value } from './utils';

export * from './env-constants';

// @TODO:  [redacted]#############################

export const MenuItemTypes = Object.freeze({
  dropdown: 'dropdown',
  link: 'link',
  heading: 'heading',
});

export const ButtonTypes = Object.freeze({
  PRIMARY_CTA: 'Primary Cta',
  SECONDARY_CTA: 'Secondary Cta',
  HYPERLINK: 'Hyperlink',
  SECONDARY: 'Secondary',
  DEFAULT: 'Default',
  FULL_WIDTH: 'Full Width',
});

export const ButtonVersion = Object.freeze({
  LEGACY_BUTTON: 'button',
  TARGET: 'targetButton',
});

export const TargetButtonTargets = Object.freeze({
  MODAL: 'Modal',
  DEFAULT: 'Default',
  NEW_TAB: 'New Tab',
});

export const Contentful = Object.freeze({
  CONTENT_TYPE_ID: 'sys.contentType.sys.id',
  EMBEDDED_ENTRY_CONTENT_TYPE_ID: 'data.target.sys.contentType.sys.id',
  EMBEDDED_ASSET_CONTENT_TYPE_ID: 'data.target.sys.type',
});

export const ContentfulTemplates = Object.freeze({
  ARTICLE: 'article',
  BLOG_OVERVIEW: 'overviewTemplate',
  BLOG_POST: 'blogPostTemplate',
  EVENT: 'event',
  HOMEPAGE: 'homepage',
  HUB: 'hub',
  LANDING_PAGE: 'landingPage',
  PAGE: 'template',
  PARTNER_DIRECTORY: 'partnerDirectory',
  PARTNER_PAGE: 'partnerPage',
  PLAID_FORUM_TEMPLATE: 'plaidForumTemplate',
  PRODUCT_PAGE: 'productPage',
  TOPIC: 'topic',
  USE_CASE: 'useCase',
});

export const TemplatesToSubdirectories = Object.freeze({
  [ContentfulTemplates.BLOG_OVERVIEW]: 'blog',
  [ContentfulTemplates.BLOG_POST]: 'blog',
  [ContentfulTemplates.LANDING_PAGE]: '', // empty string represents root
  [ContentfulTemplates.PARTNER_DIRECTORY]: '',
  [ContentfulTemplates.PRODUCT_PAGE]: 'products',
  [ContentfulTemplates.USE_CASE]: 'use-cases',
  [ContentfulTemplates.EVENT]: 'events',
  [ContentfulTemplates.TOPIC]: 'resources',
  [ContentfulTemplates.HUB]: 'resources',
  [ContentfulTemplates.ARTICLE]: 'resources',
  [ContentfulTemplates.PLAID_FORUM_TEMPLATE]: 'plaid-forum',
});

export const StaticTemplates = Object.freeze({
  WHAT_IS_PLAID: 'whatIsPlaid',
  WHY_PLAID_IS_INVOLVED: 'whyPlaidIsInvolved',
  CONTACT_THANKS: 'contactThanks',
  CONTACT: 'contact',
  DEVELOPER_POLICY: 'developerPolicy',
  DISCOVER_APPS: 'discoverApps',
  GLOBAL: 'global',
  HOW_IT_WORKS: 'howItWorks',
  HOW_WE_HANDLE_DATA: 'howWeHandleData',
  OPEN_BANKING: 'openBanking',
  PARTNERS: 'partners',
  TROUBLE_CONNECTING: 'troubleConnecting',
});

export const CmsComponents = Object.freeze({
  ACCORDION: 'accordion',
  ACCOUNT_TABLE_SECTION: 'accountTableSection',
  AEO_MARKDOWN: 'aeoMarkdown',
  CALCULATOR: 'sectionCalculator',
  ANCHOR: 'anchor',
  ASSET: 'asset',
  AUTHOR: 'author',
  BACKGROUND_CONTAINER: 'backgroundContainer',
  BLOG_POST_EXCERPT: 'blogPostExcerpt',
  BUTTON: 'button2',
  BUTTON_GROUP: 'buttonGroup',
  CARD: 'card',
  CARDS_SECTION: 'cardsSection',
  CAROUSEL: 'carousel2',
  CODE_SNIPPET: 'codeSnippet',
  CONTACT_FORM: 'sectionContactForm',
  CONTENT_BLOCK: 'mvpContentBlock',
  CTA_BANNER: 'ctaBanner',
  CTA_BLOCK_WITH_BUTTONS: 'ctaBlockWithButtons',
  CTA_BLOCK_WITH_IMAGE: 'ctaBlockWithImage',
  DECORATIVE_STAT_SECTION: 'decorativeStatSection',
  DECORATIVE_TEXT: 'decorativeText',
  DESCRIPTION_ROW: 'descriptionRow',
  EMBEDDED_VIDEO_CARD: 'embeddedVideoCard',
  EVENT_LIST: 'eventList',
  FEATURE_FLAG: 'featureFlag',
  FEATURES_SECTION: 'mvpFeaturesSection',
  FOOTER: 'footer',
  FORM_CTA: 'formCta',
  GATED_CONTENT: 'gatedContent',
  GRID_COLUMN: 'gridColumn',
  GRID_CONTAINER: 'gridContainer',
  GUILLOCHE: 'guilloche',
  HERO: 'hero2',
  HERO_LARGE_IMAGE: 'heroLargeImage',
  HIDE_FROM_AEO: 'hideFromAeo',
  HYPERLINK: 'hyperlink',
  ICON: 'icon',
  IMAGE: 'image',
  INTERACTIVE_DATA: 'interactiveData',
  INTRO_SECTION: 'introSection',
  ITEMS: 'items',
  LEAD_FORM: 'leadForm',
  LEFT_RIGHT_SECTION: 'leftRightSection',
  LEGACY_CAROUSEL: 'carousel',
  LOGOS: 'logos',
  MARKDOWN: 'markdown',
  MARKETO_FORM: 'marketoForm',
  PAGE_HEADER: 'mvpPageHeader',
  PAGE_HEADER_WITH_FORM: 'pageHeaderWithForm',
  PARTNERS_LIST: 'partnerCardsDiverse',
  PARTNER_DIRECTORY_PAGE_HEADER: 'partnerDirectoryPageHeader',
  PARTNER_PAGE_HEADER: 'partnerPageHeader',
  PAYWALL: 'paywall',
  PILL: 'pill',
  PLACEHOLDER: 'placeholder',
  PRODUCTS_PAGE_HEADER: 'productsPageHeader',
  PRODUCT_DATA_SECTION: 'productData',
  QUOTE: 'quote',
  QUOTE_CMS: 'mvpQuoteComponent',
  QUOTE_WITH_IMAGE: 'quoteWithImage',
  RAW_HTML: 'rawHtml',
  RICH_TEXT_COMPONENT: 'richTextComponent',
  RICH_TEXT_HIGHLIGHTS_SECTION: 'richTextHighlightsSection',
  SECTION: 'section',
  SECTIONAL_HEADER: 'sectionalHeader',
  SECTION_ASSET: 'sectionAsset',
  SECTION_FAQ: 'sectionFaq',
  SHOWCASE: 'mvpShowcaseComponent',
  SIMPLE_STATS_SECTION: 'simpleStatsSection',
  SOCIAL_PROOF: 'mvpSocialProofComponent',
  SPACER: 'spacer',
  STATIC_DATA: 'staticData',
  STAT_BLOCK: 'statBlock',
  SUBNAV: 'subnav',
  SUPPORTING_TEXT: 'supportingText',
  TAG: 'tag',
  TESTIMONIAL_SECTION: 'testimonialSection',
  TILE_GROUP: 'tileGroup',
  TIMELINE: 'timeline',
  VIDEO_EMBED: 'videoEmbed',
  VIDEO_WITH_FALLBACK_IMAGE: 'videoWithFallbackImage', // TODO: deprecate this - [redacted]#####################################
});

export const CmsPlaceholders = Object.freeze({
  CAREERS_SEARCH: 'Careers Search',
});

export const Locales = Object.freeze({
  EN_US: 'en-us',
  EN_EU: 'en-eu',
  EN_GB: 'en-gb',
});

export type TLocale = (typeof Locales)[keyof typeof Locales];

// map old contentful faux locale values to the new iso locale codes
// deprecated and should not be used
export const LocaleMap = Object.freeze({
  es: 'es-es',
  eu: 'en-eu',
  fr: 'fr-fr',
  uk: 'en-gb',
  us: 'en-us',
  ca: 'en-ca',
});

export const ContentfulLocales = new Set(['en-US', 'en-EU', 'en-GB']);

export const RichTextComponents = Object.freeze({
  BUTTON: 'button',
  IMAGE: 'image',
  RAW_HTML: 'rawHtml',
  CODE_SNIPPET: 'codeSnippet',
  BLOCKQUOTE: 'blockquote',
  CTA_BUTTON_WITH_TRACKING: 'ctaButtonWithTracking',
  TOOLTIP: 'tooltip',
  QUOTE_WITH_IMAGE: 'quoteWithImage',
});

export const RichTextAssets = Object.freeze({
  ASSET: 'Asset',
});

export const HubTypes = Object.freeze({
  RESOURCES: 'Resources',
});

export const TileTypes = Object.freeze({
  PEOPLE_SPOTLIGHT: 'peopleSpotlightEntry',
});

export const BLOG_ENTRIES_PER_PAGE = 15;
export const MAX_EXCERPT_WORD_COUNT = 28;
export const MAX_EXCERPT_WORD_COUNT_FEATURED = 46;

export const STATIC_IMAGE_QUALITY = 75;
export const CMS_IMAGE_QUALITY = 70;
export const LAZY_OFFSET = 400;

// Resources constants
export const RESOURCES_PATH = '/resources';

export enum FormTypes {
  Legacy = 'LEGACY_FORM',
  Gated = 'GATED_CONTENT_FORM',
  CMS = 'CMS',
}

export const PAYWALL_SELECTOR = '.paywall-noop';
export const PaywallRenderOptions = Object.freeze({
  MODAL: 'Open component in modal',
});
export const PaywallButtonAppearances = Object.freeze({
  PRIMARY: 'Primary',
  SECONDARY: 'Secondary',
});

// TODO: modal and stay on screen will need to be wired up at some point in the Button Group
// alternatively they can be removed with an application based on some context
export const targetMap = Object.freeze({
  Default: '_self',
  Modal: '_self',
  'New Tab': '_blank',
  'Stay On Screen': '_self',
  'new window': '_blank',
  'same window': '_self',
  'New tab': '_blank',
  'Same tab': '_self',
});

export const LOCALES = Object.freeze({
  EN_US: 'en-US',
  EN_EU: 'en-EU',
  EN_GB: 'en-GB',
});

export const CmsThemes = Object.freeze({
  WEB2: 'web 2.0',
  WEB3: 'web 3.0',
});

export const HeroImageOrientations = Object.freeze({
  TOP: 'Top',
  BOTTOM: 'Bottom',
});

export const HeroImageOrientationValues = Object.values(HeroImageOrientations);

export type THeroImageOrientation = Value<typeof HeroImageOrientationValues>;

export const HeroImageWidths = Object.freeze({
  CROPPED: 'Cropped',
  FULL_WIDTH: 'Full Width',
});

export const HeroImageWidthValues = Object.values(HeroImageWidths);

export type THeroImageWidth = Value<typeof HeroImageWidthValues>;

export const ComponentModes = Object.freeze({
  LIGHT: 'light',
  DARK: 'dark',
});

export const ComponentModeValues = Object.values(ComponentModes);

export type TComponentMode = Value<typeof ComponentModeValues>;

export const ComponentSolidBackgroundColors = Object.freeze({
  WHITE: 'white',
  GRAY: 'gray',
  BLACK: 'black',
  TRANSPARENT: 'transparent',
});

export const ComponentSolidBackgroundColorsValues = Object.values(
  ComponentSolidBackgroundColors,
);

export type TComponentSolidBackgroundColor = Value<
  typeof ComponentSolidBackgroundColors
>;

export const ComponentGradientBackgroundColors = Object.freeze({
  STARK_BENJAMIN: 'gradient/background/stark/benjamin',
  STARK_ELIZABETH: 'gradient/background/stark/elizabeth',
  STARK_EURO: 'gradient/background/stark/euro',
  STARK_LINCOLN: 'gradient/background/stark/lincoln',
  STARK_VIOLA: 'gradient/background/stark/viola',
  SUBTLE_BENJAMIN: 'gradient/background/subtle/benjamin',
  SUBTLE_ELIZABETH: 'gradient/background/subtle/elizabeth',
  SUBTLE_EURO: 'gradient/background/subtle/euro',
  SUBTLE_LINCOLN: 'gradient/background/subtle/lincoln',
  SUBTLE_VIOLA: 'gradient/background/subtle/viola',
  VIBRANT_BENJAMIN: 'gradient/background/vibrant/benjamin',
  VIBRANT_ELIZABETH: 'gradient/background/vibrant/elizabeth',
  VIBRANT_EURO: 'gradient/background/vibrant/euro',
  VIBRANT_LINCOLN: 'gradient/background/vibrant/lincoln',
  VIBRANT_VIOLA: 'gradient/background/vibrant/viola',
});

export const ComponentGradientBackgroundColorValues = Object.values(
  ComponentGradientBackgroundColors,
);

export type TComponentGradientBackgroundColor = Value<
  typeof ComponentGradientBackgroundColors
>;

export const ComponentBackgroundColors = Object.freeze({
  ...ComponentSolidBackgroundColors,
  ...ComponentGradientBackgroundColors,
});

export const ComponentBackgroundColorValues = Object.values(
  ComponentBackgroundColors,
);

export type TComponentBackgroundColor = Value<typeof ComponentBackgroundColors>;
// As of 2025-05-22
// Production -> https://app.contentful.com/spaces/ss5kfr270og3/entries/41XgnRz0lVI6iwfuGEfRMv
// Development -> https://app.contentful.com/spaces/ss5kfr270og3/environments/development/entries/3Yl9IvvvM1ee9SDZCEqbMB
export const CmsCareersConfigData = Object.freeze({
  DEV: '41XgnRz0lVI6iwfuGEfRMv',
  PROD: '41XgnRz0lVI6iwfuGEfRMv',
});

// TODO: refactor all the locales
export const AnotherLocaleMap = Object.freeze({
  'en-us': 'en-US',
  'en-eu': 'en-EU',
  'en-gb': 'en-GB',
});

export const CONTACT_FORMS = new Set([2006, 2007]);
